module.exports = __webpack_public_path__ + "img/Teams.c12d27fc.svg";